﻿const AppRouter = require("./router.js"),
  CustomerInfo = require("@cirrus/legacy/app-common/customer-info.js").default

require("@cirrus/legacy/app-common/backbone-ext/marionette.handlebars.webpack")
require("@cirrus/legacy/vendor-bower/js-url/url")
import * as StorageManager from "@cirrus/legacy/app-common/storage-manager.es6"

import { CoreConfig } from "@cirrus/core"

function handleSettings(response) {
  return new Promise((resolve, reject) => {
    App.Lang = "en-Gb"
    const lang = sessionStorage.getItem("urlLang")

    if (lang && typeof lang == "string") {
      CustomerInfo.set("defaultLanguage", lang)
    }

    const text = require("@cirrus/legacy/app-common/utils/text")

    App.reloadTranslations = function () {
      const lang = CustomerInfo.get("defaultLanguage")
        ? CustomerInfo.get("defaultLanguage")
        : App.Lang

      App.Text = text.createTranslator(lang)
      App.trigger("translations:loaded")
    }

    App.reloadTranslations()
    App.trigger("regional:loaded")

    resolve()
  })
}

function beforeStart() {
  const stayLoggedIn = url("?stayLoggedIn")

  if (!stayLoggedIn) {
    StorageManager.clearStorage()
  }

  return new Promise((resolve, reject) => {
    App.addRegions({
      ContentRegion: "#content-region",
    })
    resolve()
  })
}

function appStart() {
  return new Promise((resolve, reject) => {
    App.router = new AppRouter()
    App.on("start", () => {
      resolve()
    })
    App.start()
  })
}

function afterStart() {
  Backbone.history.start()
  require("@cirrus/legacy/app-common/jquery-validation-localisation.js")()

  const lang = CustomerInfo.get("defaultLanguage")

  if (lang)
    document.documentElement.setAttribute(
      "lang",
      CoreConfig.params.i18n.locales.byCode[lang].shorthand,
    )
}

export function loadSkin() {
  return new Promise((resolve, reject) => {
    const skin = CustomerInfo.get("skin")

    if (!skin) {
      document.body.classList.add("default-background")
      resolve()
      return
    }

    const xhr = new XMLHttpRequest()

    try {
      xhr.open("GET", skin)

      xhr.onreadystatechange = () => {
        if (xhr.status == 200) {
          $("html").append("<style>" + xhr.responseText + "</style>")
        }

        resolve()
      }

      xhr.send()
    } catch (error) {
      resolve()
    }
  })
}

export default () => {
  $(document).ready(() => {
    beforeStart().then(loadSkin).then(handleSettings).then(appStart).then(afterStart)
  })
}
